import {AlarmClockFont} from "../../../fonts/AlarmClockFont";
import {gsap} from "gsap";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NLCText} from "@nolimitcity/slot-launcher/bin/display/NLCText";
import {Loner} from "../../../Loner";

enum VHS_Multiplier_color {
    RED = "#cd302f",
    YELLOW = "#FFE339",
    GREEN = "#05ff51"
}

export class LonerPinTheWinVHSView extends PIXI.Container implements StageLayer {
    private _vhsMulti: NLCText
    private _currentValue: number;

    constructor() {
        super();
        this.init();
        this.addChild(this._vhsMulti);
    }

    public setMulti(value: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline(),
            curr:number=this._currentValue;
        tl.add(() => {
            this._currentValue = value;
            if (curr < value) {
                this._vhsMulti.setStyle(this.specificColorTextStyle(VHS_Multiplier_color.GREEN));
            } else if (curr > value) {
                this._vhsMulti.setStyle(this.specificColorTextStyle(VHS_Multiplier_color.RED));
            } else {
                this._vhsMulti.setStyle(this.specificColorTextStyle(VHS_Multiplier_color.YELLOW));
            }
            this._vhsMulti.text = "X" + value;
        });
        if (curr !== value) {
            tl.add(() => {
                this._vhsMulti.setStyle(this.specificColorTextStyle(VHS_Multiplier_color.YELLOW));
            }, 0.4);
        }
        return tl;
    }

    public showMulti(duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => {
            this._vhsMulti.visible = true;
        })
        tl.to(this._vhsMulti, duration, {alpha: 1}, 0);
        return tl;
    }

    public hideMulti(duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.to(this._vhsMulti, duration, {alpha: 0}, 0);
        tl.add(() => {
            this._vhsMulti.visible = false;
            this._currentValue = 1
        })
        return tl;
    }

    private init(): void {
        this._vhsMulti = this.createVHSMulti();
        this._currentValue = Loner.model.isRestore?Loner.model.winMultiplier:1;
    }

    private createVHSMulti(): NLCText {
        const text: NLCText = new NLCText("X"+(Loner.model.isRestore?+Loner.model.winMultiplier:1), new PIXI.TextStyle({
            fontFamily: AlarmClockFont.REGULAR.family,
            fill: "#FFE339",
            fontSize: "44px"
        }));
        text.position.set(360, 44);
        text.anchor.set(0.5);
        text.visible = false;
        text.alpha = 0;
        return text;
    }

    private specificColorTextStyle(color: VHS_Multiplier_color): PIXI.TextStyle {
        return new PIXI.TextStyle({
            fontFamily: AlarmClockFont.REGULAR.family,
            fill: color,
            fontSize: "44px"
        })
    }

    get currentValue(): number {
        return this._currentValue;
    }

}